import { patchState, signalStore, withMethods, withState } from '@ngrx/signals';
import { AppModule } from '@core/constants/module-history.constants';
import { cloneDeep } from 'lodash-es';

type ModuleHistoryItemState = {
    route: string;
    module: string;
};
type ModuleHistoryState = {
    routes: ModuleHistoryItemState[];
    activeParentModule: AppModule | undefined;
    activeChildModule: AppModule | undefined;
};
const initialModuleHistoryItem: ModuleHistoryItemState = {
    route: '',
    module: '',
};
const initialModuleHistory: ModuleHistoryState = {
    routes: [initialModuleHistoryItem],
    activeParentModule: undefined,
    activeChildModule: undefined,
};

export const ModuleHistoryStore = signalStore(
    { providedIn: 'root' },
    withState(initialModuleHistory),
    withMethods((store) => ({
        updateRoute(route: string, module: string): void {
            patchState(store, (state) => ({
                routes: updateRouteForModule(state.routes, route, module),
            }));
        },
        deleteSavedRoutes(): void {
            patchState(store, (state) => ({
                routes: [initialModuleHistoryItem],
            }));
        },
        updateActiveParentModule(module: AppModule): void {
            patchState(store, (state) => ({
                activeParentModule: module,
            }));
        },
        deleteActiveParentModule(): void {
            patchState(store, (state) => ({
                activeParentModule: undefined as AppModule | undefined,
            }));
        },
        updateActiveChildModule(module: AppModule): void {
            patchState(store, (state) => ({
                activeChildModule: module,
            }));
        },
        deleteActiveChildModule(): void {
            patchState(store, (state) => ({
                activeChildModule: undefined as AppModule | undefined,
            }));
        },
    })),
);

function updateRouteForModule(
    routes: ModuleHistoryItemState[],
    route: string,
    module: string,
): ModuleHistoryItemState[] {
    // Search state for given module and update route value
    // If module does not yet exist in the state, add it
    let existingModuleIndex = routes.findIndex((item) => {
        return item.module === module;
    });

    if (existingModuleIndex === -1) {
        return routes.concat({ route: route, module: module });
    } else {
        // cloneDeep fixes an issue with read only objects
        let updatedRoutes = cloneDeep(routes);
        updatedRoutes[existingModuleIndex].route = route;
        return updatedRoutes;
    }
}
